import { QuickOrderRemark } from '../../../models/quick-order-remarks.entit';
import { getRBPStringId } from '../../../page/main/main-page-states';
import http, { BASE_URL_3 } from '../../http';

const quickOrderRemarksApi = {
  // *********************
  //  快速订单备注
  // *********************
  /**
   * 获取快速订单备注信息
   */
  async getQuickOrderRemarks(): Promise<QuickOrderRemark[]> {
    return await http.get(`${BASE_URL_3}/order_remarks/${getRBPStringId()}`);
  },
  /**
   * 创建快速订单备注信息
   */
  async postQuickOrderRemarks(params: any): Promise<any> {
    return await http.post(
      `${BASE_URL_3}/order_remarks/${getRBPStringId()}`,
      params,
    );
  },
  /**
   * 编辑快速订单备注信息
   */
  async patchQuickOrderRemarks(params: any): Promise<any> {
    return await http.patch(
      `${BASE_URL_3}/order_remarks/${params.id}/${getRBPStringId()}`,
      params,
    );
  },
  /**
   * 删除快速订单备注信息
   */
  async delQuickOrderRemarks(id: number): Promise<any> {
    return await http.delete(
      `${BASE_URL_3}/order_remarks/${id}/${getRBPStringId()}`,
    );
  },
  /**
   * 批量删除快速订单备注信息
   */
  async delBatchQuickOrderRemarks(params: { ids: number[] }): Promise<any> {
    return await http.delete(`${BASE_URL_3}/order_remarks/${getRBPStringId()}`, {
      data: params
    });
  },
};
export default quickOrderRemarksApi;
